<!-- @format -->

<div *transloco="let t" class="search-page container sis-pt-md">
  <div class="search-title row">
    <div class="col-12">
      <h2 data-cy="page-secondary-title" translate>SEARCH_FOR_UNIVERSITY_OFFERING</h2>
    </div>
  </div>
  <p class="guidance" translate>SEARCH_PAGE_SECONDARY_TITLE</p>

  <div class="search-and-results scroll-target">
    <sis-search
      [guidance]="'COURSE_UNIT_SEARCH_PLACEHOLDER'"
      (searchTrigger)="onSearchParameterChange($event)"
      [searchResult]="searchResult$ | async">
      <ng-template sisSearchFilter>
        <sis-search-filter-organisation-id />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-curriculum-periods [key]="'curriculumPeriodId'" [label]="t('SEARCH.FILTER_TAGS.CURRICULUMPERIODS')" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-code-book
          [key]="'studyLevel'"
          [label]="t('SEARCH.FILTER_TAGS.STUDYLEVELURNS')"
          [codeBookUrn]="'urn:code:study-level'" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-code-book
          [key]="'attainmentLanguage'"
          [label]="t('SEARCH.FILTER_TAGS.ATTAINMENTLANGUAGES')"
          [codeBookUrn]="'urn:code:language'" />
      </ng-template>
      <ng-template sisSearchFilter>
        <app-search-filter-assessment-item-type />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-code-book
          [key]="'teachingLanguage'"
          [label]="t('SEARCH.FILTER_TAGS.TEACHINGLANGUAGE')"
          [codeBookUrn]="'urn:code:language'" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-study-periods [key]="'activityPeriod'" [label]="t('SEARCH.FILTER_TAGS.ACTIVITYPERIODS')" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-code-book
          [key]="'studyField'"
          [label]="t('SEARCH.FILTER_TAGS.STUDYFIELDURNS')"
          [codeBookUrn]="'urn:code:study-field'"
          [optionValueRegexFilter]="'okm-\\d+$'" />
      </ng-template>
      <ng-template sisSearchFilter>
        <sis-search-filter-combobox
          [key]="'enrolmentPeriodValidity'"
          [label]="t('SEARCH.FILTER_TAGS.ENROLMENTPERIODS')"
          [options]="enrolmentPeriodOptions" />
      </ng-template>
    </sis-search>

    <sis-search-results>
      @if (searchResult$ | async; as searchResult) {
        <div class="below-searchbar row">
          @if (!searchResult.truncated && searchResult?.total > 0) {
            <div class="results-info col-12">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <sis-search-result-counts
                    [id]="'results-show-guide'"
                    [showMoreEnabled]="false"
                    [searchResult]="searchResult"
                    [resultHeadingLevel]="2"></sis-search-result-counts>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="float-start float-sm-end">
                    <label id="sort-method-dropdown-label" class="choose-sort-type" translate
                      >SEARCH.SORT_SELECTOR.CHOOSE_SORT_METHOD</label
                    >
                    <sis-dropdown-select
                      [ariaLabelledBy]="'sort-method-dropdown-label'"
                      [options]="searchSortOptions"
                      [selection]="searchService.sort$ | async"
                      (selectionChange)="sort($event)"
                      [alignRight]="true"
                      data-cy="sort-search-results">
                    </sis-dropdown-select>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="results col-12">
            @if (viewData$ | async; as viewData) {
              @for (result of searchResult?.searchResults | slice: 0 : resultsPerPage; track result) {
                <div data-cy="student-courseunit-search-resultrow">
                  <app-search-result-row
                    [studyPeriods]="viewData.studyPeriodInfos"
                    [curriculumPeriods]="viewData.curriculumPeriods"
                    [result]="result"
                    [term]="searchService.fullTextQuery$ | async"
                    [searchFilterCurriculumPeriodIds]="curriculumPeriodIds$ | async"
                    [courseCartCourseUnitIds]="courseCartCourseUnitIds"
                    [loggedIn]="isLoggedIn()"
                    (addCourseUnitToCourseCart)="addCourseUnitToCourseCart($event)"
                    (removeCourseUnitFromCourseCart)="removeCourseUnitFromCourseCart($event)"></app-search-result-row>
                </div>
              }
            }
          </div>

          @if (!searchResult.truncated && searchResult?.total > this.resultsPerPage) {
            <div class="search-result-pagination row">
              <div class="col-12" data-cy="pagination-controls">
                <fudis-pagination
                  [pageCount]="totalPages$ | async"
                  [pageIndex]="currentPage - 1"
                  [paginationAriaLabel]="'SEARCH_FILTER_TITLE' | translate"
                  [autoFocusOnPageChange]="false"
                  (pageChange)="onPaginationChange($event)"></fudis-pagination>
              </div>
            </div>
          }
        </div>
      }
    </sis-search-results>
  </div>
</div>
